// import md5 from "js-md5";
const CryptoJS = require("crypto-js"); //引用AES源码js
const pageConfig = require("../../config/config"); //引入公共配置文件
import { $uCommon } from "./uCommon";
//解密方法
function Decrypt(word, type) {
  let cipher = getKeyByType(type);
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  // let srcs = CryptoJS.enc.Utf8.parse(word);
  let decrypt = CryptoJS.AES.decrypt(srcs, cipher.key, {
    iv: cipher.iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}
//加密方法
function Encrypt(word, type) {
  let cipher = getKeyByType(type);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, cipher.key, {
    iv: cipher.iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
}
/**
 * 根据类型获取 密钥和偏移量
 * @param type 接口类型
 * @returns {{iv: string, key: string}}
 */
function getKeyByType(type) {
  type = type || "default";
  let key = ""; //十六位十六进制数作为密钥
  let iv = ""; //十六位十六进制数作为密钥偏移量
  if (type == "default") {
    key = CryptoJS.enc.Utf8.parse(pageConfig.publicKey);
    iv = CryptoJS.enc.Utf8.parse(pageConfig.publicKey.substr(0, 16));
  }
  return {
    key,
    iv,
  };
}
export default {
  Decrypt,
  Encrypt,
};
function HmacSHA256(word) {
  let key = CryptoJS.enc.Utf8.parse(pageConfig.publicKey); //十六位十六进制数作为密钥
  let encrypted = CryptoJS.HmacSHA256(word, key);
  var encryptedHex = CryptoJS.enc.Hex.stringify(encrypted);
  return encryptedHex;
}

/**
 * 接口加密前处理
 * @param url    接口url
 * @param params 接口参数
 * @param header 请求头
 * @param channelType 接口渠道类型，用于区分接口地址、加解密协议等
 * @returns {{baseURL, headers, params, url}}
 */
export const apiEncryptHandle = function (url, params, header, channelType) {
  let baseURL, channel, headers;
  channelType = channelType || "default";

  let channelTypeObj = {
    //默认接口
    default: () => {
      channel = pageConfig.proxyUrl.defult;
      baseURL = pageConfig.root[0];
      if (pageConfig.isTest) {
        baseURL = pageConfig.root[2]; //测试环境
      }
    },
    //三方播放视频地址
    videoUrl: () => {
      baseURL = "https://vcsplay.its-sc.com.cn/";
      channel = "api";
    },
    //三方天气点位
    weatherPoint: () => {
      console.log(111);
    },
    Traffic: () => {
      baseURL = "https://etc.scjtonline.cn/SiChuanGSTServer/index.php?/";
      channel = "";
    },
    roadsToll: () => {
      baseURL = "https://msg.scjtonline.cn:6008/";
      channel = "";
    },
    cctvmgr: () => {
      baseURL = "https://cctvmgr.its-sc.com.cn:6443";
      channel = "";
    },
  };

  channelTypeObj[channelType]();
  headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    "Authorization": "Bearer " + (localStorage.getItem("token") || ""),
  };
  if (params) {
    params = {
      data: JSON.stringify(params) == "{}" ? null : params,
    };
    //精确到秒
    params.timestamp = new Date().getTime().toString().substr(0, 10);
    let signStr = JSON.stringify(params);
    params.sign = HmacSHA256(signStr);
    params = Encrypt(JSON.stringify(params));
  }

  // if (channelType == "default") {
  //   channel = pageConfig.proxyUrl.defult;
  //   baseURL = pageConfig.root[0];
  //   if (pageConfig.isTest) {
  //     baseURL = pageConfig.root[2]; //测试环境
  //   }
  //   headers = {
  //     "Content-Type": "application/x-www-form-urlencoded",
  //   };
  //   // if (params) {
  //   //   params = {
  //   //     data: params,
  //   //     fun: url,
  //   //   };
  //   //   params.timestamp = new Date().getTime();
  //   //   let signStr = `${params.fun}${params.timestamp}`;
  //   //   params.sign = md5(signStr);
  //   //   params = Encrypt(JSON.stringify(params));
  //   //   url = "";
  //   // }
  // }

  if (!!header) {
    for (let i in header) {
      headers[i] = header[i];
    }
  }
  return {
    baseURL: baseURL + channel,
    url,
    params,
    headers,
  };
};

/**
 * 接口统一解密处理
 * @param ciphertext   密文
 * @param channelType  接口类型
 * @returns {{msg: string, data: null, status: boolean}}
 */
export const apiDecryptHandle = function (ciphertext, channelType) {
  channelType = channelType || "default";
  let decodeData = {
    status: false, //true-成功  false-失败
    data: null, //请求返回的所有参数
    msg: "返回数据格式有误！", //错误提示
  };
  if (channelType == "default") {
    ciphertext = Decrypt(ciphertext, channelType);
    let json = $uCommon.isJSON(ciphertext);
    if (!!json) {
      decodeData.data = json;
      if (json.status == 200) {
        decodeData.status = true;
        delete decodeData.msg;
      } else {
        decodeData.msg = json.msg;
      }
    }
  }

  //console.log(decodeData);
  return decodeData;
};
